import * as React from 'react';
import { IconInfrastructureParking16 } from '@cian/ui-kit-design-tokens/icons';

import { EmptyField, TextAndIconField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const ParkingFieldContainer: React.VFC = () => {
  const { newbuilding, published } = useOfferContext();
  const parking = newbuilding && newbuilding.parking;

  const displayParking = React.useMemo(
    () => (parking ? parking.map(parking => ({ icon: <IconInfrastructureParking16 />, text: parking.text })) : []),
    [parking],
  );

  if (!displayParking.length) {
    return <EmptyField published={published} />;
  }

  return <TextAndIconField published={published} items={displayParking} />;
};
